/** Nombre accesible del `LoadingOverlay` general del sitio mientras navega a
 * la variante localizada de la página tras elegir otra provincia. */
export const LOCATION_CHANGE_LOADING_LABEL = 'Cargando la agenda de la nueva localización'
